import firebaseChatService from '../services/firebaseChatService';
import { chatSdk } from '@wix/chat-sdk';
import { initApp } from './serverApi';
import { updateAllowInput, updateIsLcfMandatory } from './index';

export const onVisitorMerge = event => (dispatch, getState) => {
  if (event.mergedIntoChatroomId) {
    dispatch(updateAllowInput(true));
  }

  dispatch(
    updateIsLcfMandatory({ ...getState().isLcfMandatory, isContact: true }),
  );
  firebaseChatService.updatePresence({
    isContact: true,
  });

  if (
    !event.mergedIntoChatroomId ||
    event.mergedIntoChatroomId === event.visitorChatroomId
  ) {
    return;
  }

  chatSdk.disconnect();

  return dispatch(
    initApp({
      reconnectData: {
        refresh: true,
        oldVisitorInstanceId: firebaseChatService.visitorInstanceId,
        prevChatToken: getState().coreChatToken,
      },
    }),
  );
};
